import { BASE_PATH } from '@/configs';

export const assetsPath = (url: string) => {
  if (!BASE_PATH) {
    return url;
  }

  return new URL(url, BASE_PATH).href;
};
